module.exports = __webpack_public_path__ + "static/media/html5.ce6e5ba0.svg";